import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    activeFilter: String
  }

  // Estados exclusivos por pestaña
  internacionesStates = ['activas', 'finalizadas', 'vencidas', 'anuladas']
  serviciosStates = ['pendiente_inicio', 'activos', 'finalizados', 'proximos_vencimiento']

  connect() {
    this.initializeButtons()
    
    // Re-actualizar cuando Turbo carga una nueva página
    document.addEventListener('turbo:load', () => {
      this.initializeButtons()
    })
  }

  initializeButtons() {
    // Obtener el parámetro 'status' de la URL
    const params = new URLSearchParams(window.location.search)
    const currentStatus = params.get('status')
    const currentTab = params.get('tab') || 'internaciones'
    
    // Validar que el status sea compatible con la pestaña
    if (currentStatus && !this.isStatusCompatibleWithTab(currentStatus, currentTab)) {
      // Si el status es incompatible, limpiar
      console.warn(`Status ${currentStatus} not compatible with tab ${currentTab}. Cleaning...`)
      this.clearFilter()
      return
    }
    
    if (!currentStatus || currentStatus === 'todos') {
      // Estado inicial: mostrar todos los botones
      this.resetToInitialState()
    } else {
      // Filtro activo: ocultar otros botones y mostrar X
      this.showActiveFilter(currentStatus)
    }
  }

  isStatusCompatibleWithTab(status, tab) {
    if (tab === 'internaciones') {
      return this.internacionesStates.includes(status)
    } else if (tab === 'servicios') {
      return this.serviciosStates.includes(status)
    }
    return true
  }

  resetToInitialState() {
    // Mostrar todos los botones
    const buttons = this.element.querySelectorAll('[data-quick-filter-btn]')
    buttons.forEach(btn => {
      btn.classList.remove('btn-quick-filter-hidden')
      btn.classList.remove('btn-quick-filter-active-green')
      
      if (btn.getAttribute('data-quick-filter-value') === 'todos') {
        btn.classList.remove('btn-quick-filter-inactive')
        btn.classList.add('btn-quick-filter-active')
      } else {
        btn.classList.remove('btn-quick-filter-active')
        btn.classList.add('btn-quick-filter-inactive')
      }
      
      // Ocultar la X
      const closeIcon = btn.querySelector('[data-btn-close]')
      if (closeIcon) {
        closeIcon.style.display = 'none'
      }
    })
  }

  showActiveFilter(status) {
    const buttons = this.element.querySelectorAll('[data-quick-filter-btn]')
    
    buttons.forEach(btn => {
      const btnStatus = btn.getAttribute('data-quick-filter-value')
      
      if (btnStatus === status) {
        // Mostrar este botón con X y estilo según el estado
        btn.classList.remove('btn-quick-filter-hidden')
        btn.classList.remove('btn-quick-filter-inactive', 'btn-quick-filter-active')
        
        // Aplicar clase específica según el estado
        if (status === 'proximos_vencimiento') {
          btn.classList.add('btn-quick-filter-active-yellow')
          btn.classList.remove('btn-quick-filter-active-green', 'btn-quick-filter-active-red')
        } else if (status === 'finalizados' || status === 'finalizadas') {
          btn.classList.add('btn-quick-filter-active-red')
          btn.classList.remove('btn-quick-filter-active-green', 'btn-quick-filter-active-yellow')
        } else {
          btn.classList.add('btn-quick-filter-active-green')
          btn.classList.remove('btn-quick-filter-active-yellow', 'btn-quick-filter-active-red')
        }
        
        // Mostrar la X
        const closeIcon = btn.querySelector('[data-btn-close]')
        if (closeIcon) {
          closeIcon.style.display = 'inline'
        }
      } else {
        // Ocultar los demás botones
        btn.classList.add('btn-quick-filter-hidden')
      }
    })
  }

  filterByStatus(event) {
    console.log('filterByStatus called', event.target)
    const button = event.target.closest('[data-quick-filter-btn]')
    console.log('button:', button)
    if (!button) return
    
    const status = button.getAttribute('data-quick-filter-value')
    console.log('status:', status)
    
    // Si hace click en la X, limpiar filtro
    if (event.target.closest('[data-btn-close]')) {
      this.clearFilter()
      return
    }
    
    if (status === 'todos') {
      this.clearFilter()
      return
    }
    
    // Construir la URL con el nuevo filtro, preservando todos los parámetros existentes
    const params = new URLSearchParams(window.location.search)
    const currentTab = params.get('tab') || 'internaciones'
    console.log('currentTab:', currentTab)
    
    params.set('status', status)
    params.set('tab', currentTab)
    params.delete('page')  // Solo remover page, mantener fecha_desde, fecha_hasta, etc.
    
    const newUrl = `${window.location.pathname}?${params.toString()}`
    console.log('Navigating to:', newUrl)
    console.log('Full URL:', window.location.href)
    Turbo.visit(newUrl, { action: 'advance' })
  }

  clearFilter() {
    // Construir la URL sin el status, pero manteniendo TODOS los otros parámetros
    const params = new URLSearchParams(window.location.search)
    params.delete('status')  // Solo remover status, mantener fecha_desde, fecha_hasta, etc.
    // Mantener el tab actual
    const currentTab = params.get('tab') || 'internaciones'
    params.set('tab', currentTab)
    params.delete('page')  // Solo remover page
    
    Turbo.visit(`${window.location.pathname}?${params.toString()}`, { action: 'advance' })
  }
}
